import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { TenGameClub } from './models/ten-game-club.model';

export interface TenGameClubState extends EntityState<TenGameClub> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'tenGameClub', idKey: 'Id', cache: { ttl: 20000} })
export class TenGameClubStore extends EntityStore<TenGameClubState> {

  constructor() {
    super();
  }

}

